<template>
  <span class="line-token" :class="{ sirah: isSirah, selectedToken: isSelected }">{{ value }}</span>
</template>

<script>
  export default {
    props: ['token'],
    computed: {
      value() {
        return this.token.value;
      },
      pos() {
        return this.token.pos;
      },
      isSirah() {
        return this.token.is_sirah;
      },
      isSelected() {
        return this.token.selected;
      },
    },
  };
</script>

<style lang="scss">
  @import '../../variables';

  .line-token {
    padding: 0px 4px;
    margin: 0 -4px;
  }
  .show-sirah .line-token.sirah {
    background: $gray-300;
    &.selectedToken {
      /* more explicit than using !important below */
      background: rgba(255, 251, 0, 0.5);
    }
  }
  .selectedToken {
    background: rgba(255, 251, 0, 0.5);
  }
  /*
  Override padding and apply a border to prevent
  "blockiness":
  https://trello.com/c/LWwC5YRD/19-show-ibn-ishaq-text-reuse-at-the-token-level#comment-5d6d32cbbf3dbf70aaceac0c
  */
  .text-lg {
    .line-token {
      padding: 0px 6px;
      margin: 0 -6px;
    }
    .show-sirah .line-token.sirah {
      border-top: 1px solid $gray-300;
    }
  }

</style>
